module.exports = __webpack_public_path__ + "fonts/SteelfishRg-Regular.2d742577.woff2";